/**
 * This can be useful for adding spaces in inline contexts without having to
 * fight with formatjs/no-literal-string-in-jsx and so they are a bit more
 * visible in the component tree.
 */
export function SingleSpaceLiteral() {
  return " ";
}
